import { Form } from 'antd';

import { CheckboxGroup } from './ChooseCoursesChecker.styles';
import { CourseCheckbox } from './CourseCheckbox';

import { LoadingCircleSpinner } from '@/components/Loaders';
import { Box } from '@/components/Utils';
import { useMySubscriptions } from '@/store';

export const ChooseCoursesChecker = () => {
  const { planificableSubscriptions, isLoading } = useMySubscriptions();

  if (isLoading) {
    return <LoadingCircleSpinner />;
  }

  if (!planificableSubscriptions?.length) {
    return null;
  }

  return (
    <Form.Item
      name={['planification', 'subscriptions']}
      rules={[{ required: true, message: '' }]}
      valuePropName="value">
      <CheckboxGroup>
        <Box flexDirection="column" gap={12} width="100%">
          {planificableSubscriptions?.map(subscription => (
            <CourseCheckbox
              key={subscription._id}
              value={subscription._id}
              label={subscription.course.name}
              emoji={subscription.course.emoji}
            />
          ))}
        </Box>
      </CheckboxGroup>
    </Form.Item>
  );
};
